import React, { useState, FunctionComponent } from 'react';
import { Container, Typography } from '@pwskills/rachnaui';
import Link from 'next/link';
import { Mail, Call } from '@pwskills/rachnaui/Icons';
import consts, { enquiryTypes } from '@/utils/contactUs/contactUs.constants';
import EnquiryTabs from './EnquiryTabs';
import Toaster from '../common/Toaster';
import { phoneNumber } from '../CourseDescriptionPageProfessional/CourseCurriculum/constants';

const ContactUs: FunctionComponent = () => {
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');

  return (
    <div className="large:!bg-gradient-to-b from-white to-[#FFF7F5] overflow-hidden">
      <Container className="my-8 regular:my-14 text-gray-850 flex flex-col large:!flex-row justify-between regular:!gap-x-20 large:!gap-x-52">
        <div className="flex-1">
          <Typography
            component="h1"
            variant="bold"
            className="font-inter pb-3 text-center regular:!text-start text-gray-900"
          >
            {consts.CONTACT_US}
          </Typography>
          <Typography
            component="subheading"
            variant="regular"
            className="text-gray-650 pb-1 regular:!pb-3"
          >
            For any queries, Please reach out to us. Our Support team will get back to you within 24
            hours.
          </Typography>
          <Typography component="body-regular" variant="regular" className="flex items-center pt-3">
            <Mail className="w-4 h-4 mr-2 text-gray-600" />
            <Link href="mailto:support@pwskills.com" className="text-gray-650 ">
              support@pwskills.com
            </Link>
          </Typography>
          <Typography
            component="body-regular"
            variant="regular"
            className="pb-6 large:!pb-[76px] flex items-center pt-3"
          >
            <Call className="w-4 h-4 mr-2 text-gray-600" />
            <Link href={phoneNumber} className="text-gray-650">
              {phoneNumber}
            </Link>
          </Typography>
          <img
            src="/images/contactUs/employeesHelpingCustomers.svg"
            alt="contactUs"
            className="hidden large:!block"
          />
        </div>
        <div className="large:!shadow-medium rounded-xl flex-1 bg-white large:!p-14 w-full regular:!w-[80%] large:!w-full">
          <EnquiryTabs enquiryTypes={enquiryTypes} setError={setError} setSuccess={setSuccess} />
        </div>
        {error && (
          <Toaster open={!!error} setOpen={() => setError('')} text={error} variant="error" />
        )}

        {success && (
          <Toaster
            open={!!success}
            setOpen={() => setSuccess('')}
            text={success}
            variant="success"
          />
        )}
      </Container>
    </div>
  );
};

export default ContactUs;
